var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:['consent-window', { 'is-settings-active': _vm.settingsActive }]},[_c('transition',{attrs:{"name":"component-fade","mode":"out-in"}},[_c(_vm.currentView,{tag:"component",on:{"onSettings":_vm.switchOnSettings}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }